import apiService from "../../api/api.service";
import {
  ReviewsSummaryResponse,
  ReviewsListResponse,
  ReviewCreateResponse,
  ReviewUpdateResponse,
  ReviewDeleteResponse,
  CreateReviewPayload,
  UpdateReviewPayload,
  ReviewDetailResponse,
} from "./reviews.types";

export const fetchReviewsSummary = () => {
  return apiService.get<ReviewsSummaryResponse>("/customers/reviews/summary");
};

export const fetchReviews = (status?: string) => {
  const params = status ? { status } : undefined;
  return apiService.get<ReviewsListResponse>("/customers/reviews", { params });
};

export const createReview = (payload: CreateReviewPayload) => {
  const formData = new FormData();

  formData.append("product_id", payload.product_id.toString());
  formData.append("rating", payload.rating.toString());
  formData.append("comment", payload.comment);

  if (payload.order_id) {
    formData.append("order_id", payload.order_id.toString());
  }

  if (payload.images && payload.images.length > 0) {
    payload.images.forEach((image, index) => {
      formData.append(`images[${index}]`, image);
    });
  }

  if (payload.agreements && payload.agreements.length > 0) {
    payload.agreements.forEach((agreementId: number, index: number) => {
      formData.append(`agreements[${index}]`, agreementId.toString());
    });
  }

  return apiService.post<ReviewCreateResponse>("/customers/reviews", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateReview = (payload: UpdateReviewPayload) => {
  const formData = new FormData();

  formData.append("product_id", payload.product_id.toString());
  formData.append("rating", payload.rating.toString());
  formData.append("comment", payload.comment);

  if (payload.order_id) {
    formData.append("order_id", payload.order_id.toString());
  }

  if (payload.images && payload.images.length > 0) {
    payload.images.forEach((image, index) => {
      formData.append(`images[${index}]`, image);
    });
  }

  return apiService.post<ReviewUpdateResponse>(
    `/customers/reviews/${payload.id}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const deleteReview = (id: number) => {
  return apiService.delete<ReviewDeleteResponse>(`/customers/reviews/${id}`);
};

export const fetchReviewById = (id: number) => {
  return apiService.get<ReviewDetailResponse>(`/customers/reviews/${id}`);
};

export const forceDeleteReview = (id: number) => {
  return apiService.delete<ReviewDeleteResponse>(
    `/customers/reviews/${id}/force`,
  );
};